const isNumber = str => /^\d+$/.test(str)

const validationRules = {
  noConsecutiveDots: value => {
    const noConsecutiveDots = value.indexOf('..') === -1
    return noConsecutiveDots
  },
  noDotsEnding: value => {
    const noDotsEnd = value[value.length - 1] !== '.'
    return noDotsEnd
  },
  noNumericEnding: value => {
    const noNumericEnd = !isNumber(value[value.length - 1])
    return noNumericEnd
  },
  noSpaces: value => {
    const noSpaces = value.indexOf(' ') === -1
    return noSpaces
  },
}

const validateEmail = value => {
  const trimmedValue = value.trim()
  const patternValid = /^([a-zA-Z0-9-._+]+)([@]{1})([a-zA-Z0-9-.]+)([.]{1})([a-zA-Z0-9]+)$/.test(
    trimmedValue
  )

  const rulesValid = Object.values(validationRules).every(validation =>
    validation(trimmedValue)
  )

  return patternValid && rulesValid
}

module.exports = {
  validateEmail,
}
